import { AxiosResponse } from "axios";
import api from "../../utils/api";
import routes from "../../utils/apiRoutes.json";

export function getRanks(setRank: Function): Promise<AxiosResponse> {
    return api.get(
        routes.ranks,
    ).then((response) => {
        const data = response.data;
        setRank("allTimeBestRank", data.all_time_best_rank || "No information");
        setRank("rank", data.rank || "No information");
        setRank("thisWeekBestRank", data.this_week_best_rank || "No information");
        return response;
    },
    ).catch((err) => {

        throw err;
    },
    );
}
